import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {LandDTO} from '../../openapi/schluesseldaten-openapi';


export const landEntitiesAdapter: EntityAdapter<LandDTO> = createEntityAdapter<LandDTO>({
  selectId: (entity: LandDTO) => entity.kurzform!,
});
